module.exports = __webpack_public_path__ + "img/photography.c2842d02.png";